import { PlaylistSimple, TableData } from '@/types';

import { formatDurationToMinutes } from './date';

export const mapPlaylistSimpleToTableData = (item: PlaylistSimple): TableData => ({
  ...item,
  id: item.id,
  enabled: true,
  noOfAssets: item.numberOfAsset,
  totalDuration: formatDurationToMinutes(item.totalDuration) as unknown as number
});

export const isTimeSlotActive = (start?: string | Date, end?: string | Date): boolean => {
  if (!start || !end) {
    return false;
  }

  const now = new Date();
  const slotStart = new Date(start);
  const slotEnd = new Date(end);

  return now >= slotStart && now <= slotEnd;
};
